module.exports = __webpack_public_path__ + "img/rejection_image.07110fa9.svg";